import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { 
  Login,
  Home,
  AdminPanel,
  TermsConditions,
  Liability,
  Cancellation,
  SinaniumPrivacy,
  SinaniumMainPage,
  SinaniumInvite,
  Host
} from "./Screens";
import ProtectedRoute from './Screens/protectedRoute';
import 'bootstrap/dist/css/bootstrap.min.css';
import store, { persistor} from './redux/store';
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react';
import '../src/lib/i18n';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <React.StrictMode>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/terms" element={<TermsConditions />} />
            <Route path="/liability" element={<Liability />} />
            <Route path="/sinanium" element={<SinaniumMainPage />} />
            <Route path="/sinanium-galactic" element={<SinaniumInvite />} />
            <Route path="/sinanium-privacy" element={<SinaniumPrivacy />} />
            <Route path="/cancellation" element={<Cancellation />} />
            <Route path="/host" element={<Host />} />
            <Route 
              path="/admin" 
              element={
                <ProtectedRoute>
                  <AdminPanel />
                </ProtectedRoute>
              } 
            />
            <Route path="*" element={<Home />} />
          </Routes>
        </BrowserRouter>
      </React.StrictMode>
    </PersistGate>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
